import { defineStore } from 'pinia'
import axiosOverlayConnector from '@/services/axiosOverlayConnector.js'
import useUserStore from '@/stores/user.js'
import useCategorieDepenseStore from '@/stores/categorieDepense.js'

export default defineStore('categorie', {
  state: () => ({
    categories: null,
    detailsCategorie: null,
    loading: 0,
    loadingForm: 0
  }),

  getters: {
    isLoading: (state) => {
      return state.loading > 0
    },

    isLoadingForm: (state) => {
      return state.loadingForm > 0
    },

    getCategorieById: (state) => (id) => {
      if (!state.categories) return null
      return state.categories.find((categorie) => categorie.id === id)
    }
  },

  actions: {
    loadCategorieById(id) {
      this.loading++

      return new Promise((resolve, reject) => {
        let url = import.meta.env.VITE_API_URL + '/categories/' + id

        const config = {
          url: url,
          method: 'GET'
        }

        return axiosOverlayConnector(config)
          .then((response) => {
            this.detailsCategorie = response.data
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            this.loading--
          })
      })
    },

    loadCategories(fromForm = false) {
      if (fromForm) this.loadingForm++
      else this.loading++

      return new Promise((resolve, reject) => {
        let url = import.meta.env.VITE_API_URL + '/categories'

        const config = {
          url: url,
          method: 'GET'
        }

        return axiosOverlayConnector(config)
          .then((response) => {
            this.categories = response.data

            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            if (fromForm) this.loadingForm--
            else this.loading--
          })
      })
    },

    addCategorie(categorieData) {
      const userStore = useUserStore()
      const { loadCategorieDepenses } = useCategorieDepenseStore()
      this.loading++

      return new Promise((resolve, reject) => {
        let url = import.meta.env.VITE_API_URL + '/categories'

        const config = {
          url: url,
          method: 'POST',
          data: {
            ...categorieData,
            idCompte: userStore.idCompte
          }
        }

        return axiosOverlayConnector(config)
          .then((response) => {
            this.categories.push({
              ...response.data
            })

            // Ajout dans categorieDepense
            loadCategorieDepenses()

            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            this.loading--
          })
      })
    },

    updateCategorie(categorieData) {
      const { updateCategorieDepense } = useCategorieDepenseStore()
      this.loading++

      return new Promise((resolve, reject) => {
        let url = import.meta.env.VITE_API_URL + '/categories/' + categorieData.id

        const config = {
          url: url,
          method: 'PUT',
          data: {
            ...categorieData
          }
        }

        return axiosOverlayConnector(config)
          .then(() => {
            this.categories = this.categories.map((categorie) =>
              categorie.id === categorieData.id ? categorieData : categorie
            )

            // Update des informations de la catégories dans le tableau de bord
            updateCategorieDepense(categorieData)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            this.loading--
          })
      })
    },

    deleteCategorie(idCategorie) {
      const { removeCategorieDepense } = useCategorieDepenseStore()
      this.loading++

      return new Promise((resolve, reject) => {
        let url = import.meta.env.VITE_API_URL + '/categories/' + idCategorie

        const config = {
          url: url,
          method: 'DELETE'
        }

        return axiosOverlayConnector(config)
          .then(() => {
            this.categories = this.categories.filter((c) => c.id !== idCategorie)

            // Update des informations de la catégories dans le tableau de bord
            removeCategorieDepense(idCategorie)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            this.loading--
          })
      })
    }
  }
})
